import {forwardRef, Inject, Injectable} from "@angular/core";
import {AlertService} from "./alert.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./session.service";
import {EmployeeTimedTaskGroupAggregation} from "../home/task/model/EmployeeTimedTaskGroupAggregation";


/**
 * Using it to share information between frame/windows/panel
 */
@Injectable()
export class SharingService {

  private _employeeTimedTaskGroupAggregation: EmployeeTimedTaskGroupAggregation;

  constructor(
              @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
              @Inject(forwardRef(() => Router)) private router: Router,
              @Inject(forwardRef(() => SessionService)) private sessionService: SessionService,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {
  }


  public get employeeTimedTaskGroupAggregation(): EmployeeTimedTaskGroupAggregation{
    return this._employeeTimedTaskGroupAggregation;
  }

  public set employeeTimedTaskGroupAggregation(bean: EmployeeTimedTaskGroupAggregation){
    this._employeeTimedTaskGroupAggregation = bean;
  }


}
